import * as React from 'react'

interface NotifyIconProps {
  color?: string
  gradient?: boolean
  size?: number
  alt?: string
}

const NotifyIcon: React.FC<NotifyIconProps> = ({
  color = '#888',
  gradient,
  size,
  alt = 'Notify Icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 23 26'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M9.338 2.494a2.119 2.119 0 1 0 4.237 0 2.119 2.119 0 0 0-4.237 0m2.119.868a.869.869 0 1 1 0-1.737.869.869 0 0 1 0 1.737'
        clipRule='evenodd'
      ></path>
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M.375 22.636h22.163v-1.943c0-1.26-.712-2.412-1.84-2.976a2.08 2.08 0 0 1-1.148-1.858v-4.404a8.094 8.094 0 1 0-16.187 0v4.404c0 .787-.445 1.506-1.149 1.858a3.33 3.33 0 0 0-1.839 2.976zm1.25-1.25v-.693c0-.787.445-1.506 1.148-1.858a3.33 3.33 0 0 0 1.84-2.976v-4.404a6.844 6.844 0 0 1 13.687 0v4.404c0 1.26.712 2.413 1.84 2.976a2.08 2.08 0 0 1 1.148 1.858v.693z'
        clipRule='evenodd'
      ></path>
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M8.592 22.758a2.866 2.866 0 1 0 5.568-.955l-1.179.417q.091.252.092.538a1.616 1.616 0 1 1-3.14-.538l-1.178-.417q-.161.452-.163.955'
        clipRule='evenodd'
      ></path>
    </svg>
  )
}

export default NotifyIcon
